'use client';
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Modal } from '../Modal';
import { useReporter } from '../../reporter';
import { MuxVideo } from '../MuxVideo';
import { videoModalViewed } from './events';
import { StyledVideoModal } from './styles';

export const VideoModal = ({
  parentHeadline = '',
  video,
  shown,
  onClickClose,
  videoOrientation = 'landscape',
}) => {
  const reporter = useReporter();

  useEffect(() => {
    if (shown) {
      reporter.tag(videoModalViewed(video.filename, parentHeadline));
    }
  }, [reporter, shown, video.filename, parentHeadline]);

  return (
    <Modal
      shown={shown}
      onCloseModal={onClickClose}
      ariaLabel="Video Modal"
      centerModal={true}
      closeBtnColor={'background.base'}
      hideCloseBtnCircle={true}
      transparentBackground={true}
      mobileFullScreen={false}
    >
      <StyledVideoModal videoOrientation={videoOrientation}>
        <MuxVideo
          showScrollControls={true}
          playbackId={video.playbackId}
          autoplay={video.autoplay}
          loop={video.loop}
          thumbnail={video.thumbnail}
          aspectRatio={video.aspectRatio}
          parentHeading={parentHeadline}
        />
      </StyledVideoModal>
    </Modal>
  );
};

VideoModal.displayName = 'VideoModal';

VideoModal.propTypes = {
  parentHeadline: PropTypes.string,
  onClickClose: PropTypes.func.isRequired,
  shown: PropTypes.bool.isRequired,
  video: PropTypes.object.isRequired,
  videoOrientation: PropTypes.oneOf(['portrait', 'landscape']),
};
